import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './ChooseMemberType.module.scss'
// import backIcon from '../../../public/images/arrow-left.png'

const ChooseMemberType = () => {
	const navigate = useNavigate()
	const [selectedType, setSelectedType] = useState('tourPro')

	const memberTypes = [
		{ id: 'tourPro', label: '투어프로' },
		{ id: 'tourCaddie', label: '투어캐디' },
		{ id: 'houseCaddie', label: '하우스캐디', comingSoon: true },
		{ id: 'agency', label: '에이전시', comingSoon: true },
	]

	const handleTypeSelect = (typeId) => {
		// 하우스캐디와 에이젼시는 선택 불가
		if (typeId === 'houseCaddie' || typeId === 'agency') {
			return
		}
		setSelectedType(typeId)
	}

	const handleNext = () => {
		// 선택된 유형을 세션 스토리지에 저장
		sessionStorage.setItem('selectedMemberType', selectedType)
		// 다음 페이지로 이동 (예: 회원가입 폼)
		if (selectedType === 'tourPro') {
			navigate('/signup/tour-pro')
		} else if (selectedType === 'tourCaddie') {
			navigate('/signup/tour-caddie')
		} else if (selectedType === 'houseCaddie') {
			navigate('/signup/house-caddie')
		} else if (selectedType === 'agency') {
			navigate('/signup/agency')
		}
	}

	const handleBack = () => {
		navigate(-1)
	}

	return (
		<div className={styles.container}>
			<div className={styles.content}>
				{/* 상단 섹션 */}
				<div className={styles.header}>
					<div className={styles.backButtonWrapper}>
						<button className={styles.backButton} onClick={handleBack}>
							<img
								src={'/images/arrow-left.png'}
								alt="뒤로"
								style={{ width: 14, height: 14 }}
							/>
							<span
								style={{
									fontSize: 12,
									fontWeight: 500,
									fontFamily: 'Pretendard',
									color: '#7D7D7D',
								}}>
								뒤로
							</span>
						</button>
					</div>
					<img
						src={'/images/member-cover.png'}
						alt="회원가입 유형 선택"
						style={{ width: '100%' }}
					/>
					<h1 className={styles.title}>회원가입 유형 선택</h1>
				</div>

				{/* 회원 유형 선택 섹션 */}
				<div className={styles.selectionSection}>
					<div className={styles.memberTypeList}>
						{memberTypes.map((type) => (
							<button
								key={type.id}
								className={`${styles.memberTypeItem} ${selectedType === type.id ? styles.selected : ''} ${type.comingSoon ? styles.disabled : ''}`}
								onClick={() => handleTypeSelect(type.id)}
								disabled={type.comingSoon}>
								<span>{type.label}</span>
								{type.comingSoon && (
									<span className={styles.comingSoonLabel}>
										준비중입니다. 곧 만나요
									</span>
								)}
							</button>
						))}
					</div>
				</div>

				{/* 하단 다음 버튼 */}
				<div className={styles.footer}>
					<button className={styles.nextButton} onClick={handleNext}>
						다음
					</button>
				</div>
			</div>
		</div>
	)
}

export default ChooseMemberType
